 <template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-toolbar-title>Claim Event Help List</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryClmFilterForm">
          <v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex lg6 xs12>
                        <v-text-field data-vv-scope="eventTypeForm" v-model="filters.eventType" :label="filtersLabel.eventType"
                          :error-messages="errors.collect('eventType')" data-vv-name="eventType" :data-vv-as="filtersLabel.eventType" v-validate="'max:20'"/>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions right>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearClmFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text @click.prevent="doClmFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <v-data-table :headers="clmHeaders" :items="clmEventItems" v-bind:options.sync="paginationClm" :footer-props="{'items-per-page-options': itemsPerPage }" :server-items-length="totalItemsClmEvent" :loading="loading" class="elevation-1" :no-data-text="noDataText">
            <template v-slot:item="row"><tr>
              <td>{{ row.item.eventType }}</td>
              <td>{{ row.item.eventDesc }}</td>
              <td style="text-align:center">
                <v-btn text icon color="primary" type="submit" @click="assignClmEvent(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
             </tr></template>
            </v-data-table>
        </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      clmEventItems: [],
      totalItemsClmEvent: 0,
      filtersLabel: {
        eventType: 'Event Type'
      },
      filters: {
        eventType: undefined
      },
      clmHeaders: [
        { text: 'Type', align: 'left', value: 'eventType' },
        { text: 'Description', align: 'left', value: 'eventDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationClm: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearClmFilters()
  },
  watch: {
    'boolRefresh': function(value) {
      if (value) {
        this.doClearClmFilters()
      }
    },
    'paginationClm': function (value) {
      this.fetchClmEventData()
    }
  },
  methods: {
    doFilterOnEnter() {
      this.doClmFilters()
      event.preventDefault()
    },
    closeDialog() {
      this.filters.eventType = ''
      this.$emit('close')
    },
    doClearClmFilters() {
      this.filters.eventType = ''
      this.fetchClmEventData()
    },
    doClmFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryClmFilterForm').then(result => {
        if (result) {
          this.paginationClm.page = 1
          this.fetchClmEventData()
        }
      })
    },
    assignClmEvent(data) {
      // Use $emit to call parent Accounts page method assignClmEvent and pass the value
      this.$emit('assign-clm-event', data)
      this.$emit('close')
    }
  },
  computed: {
  },
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    accountNo: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    commonAjaxMixin
  ]
}
</script>
